import { IDevice } from '@portal/marketplace/api-interfaces/src/lib/devices/IDevice';

export interface IDeviceAssinedToApp {
  timeCreated: Date;
  timeUpdated: Date;
  createdBy: Date;
  appName: string;
  appVersion: string;
  merchantId: string;
  appmarketAppId: string;
  devices: IDeviceExtraData[];
  licensesData?: {
    licensesUsed: number;
    licensesAvailable: number;
  };
}

// extended device data for the app installed on devices
export interface IDeviceExtraData extends IDevice {
  assignmentType: string;
  assignmentBundleId: string;
  assignmentStatus: string;
  deploymentStatus: string;
}
